import ApiService from "@/common/api.service"

export const TrainerReportService = {
    getTraineeReports(query) {
        let queryParam = `/trainer-report${query}`;
        return ApiService.get(queryParam);
    },
    getTrainerCount(query = "") {
        return ApiService.get(`/trainer-report/count${query}`);
    },

}
